module.exports = __webpack_public_path__ + "static/media/redness.7dfe3750.svg";